export const initializeFavicon = (faviconUrl: string | undefined) => {
    if (faviconUrl) {
        document.head.insertAdjacentHTML(
            'beforeend',
            `
        <link rel="shortcut icon" href="${faviconUrl}">
        `
        );
    }
};
